import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject; /* @jsx jsx */
import '@fontsource/roboto/latin-300-italic.css';
import { jsx, css } from '../../util/emotionReact';
var Caption = function Caption(_ref) { var children = _ref.children; return jsx("span", { css: css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      text-align: center;\n      display: block;\n      padding-bottom: 2rem;\n      margin-top: -5px;\n      font-style: italic;\n    "]))) }, children); };
export default Caption;
